import { ReturnTypeEnum } from "@redotech/redo-model/return";
import * as z from "zod/v4";

export const createReturnViewFolder = {
  name: "createReturnViewFolder" as const,
  input: z.object({ name: z.string(), type: z.enum(ReturnTypeEnum) }),
  output: z.object({ folderId: z.string() }),
};
